import { Link } from 'react-router-dom';
import { ArrowLeft, Mail } from 'lucide-react';
import { useEffect } from 'react';

export function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[--bg-secondary] py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Link
          to="/"
          className="inline-flex items-center text-[--text-secondary] hover:text-[--text-primary] mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Link>

        <div className="bg-[--bg-primary] rounded-lg shadow-lg overflow-hidden">
          <div className="p-8">
            <h1 className="text-3xl font-bold text-[--text-primary] mb-6">
              Contact Us
            </h1>

            <div className="space-y-4">
              {/* --- START OF MODIFIED CONTENT --- */}

              <p className="text-[--text-primary]">
                Thank you for your interest in Scholar42. We're a passionate team dedicated to making academic research a little less overwhelming—and a lot more efficient. If you have any questions, feedback, or simply want to share how we can do better, we'd love to hear from you.
              </p>

              <p className="text-[--text-primary] font-semibold">
                We're here to help with:
              </p>
              <ul className="list-disc list-inside text-[--text-secondary] space-y-1">
                <li>Troubleshooting or technical support</li>
                <li>Questions about how to get started with Scholar42</li>
                <li>Suggestions for improvement—we're always learning</li>
                <li>Partnership or collaboration ideas</li>
                <li>Any thoughts you'd like to share</li>
              </ul>

              <p className="text-[--text-primary] font-semibold">
                Reach out anytime at:
              </p>
              <div className="flex items-center">
                <Mail className="w-5 h-5 text-[--link-default] mr-3" />
                <span className="text-[--text-secondary]">support@scholar42.com</span>
              </div>

              <p className="text-[--text-primary]">
                We usually reply within <strong>24–48 hours</strong>. As a dedicated team, we genuinely care about every message and try to respond as quickly and thoughtfully as possible—even on weekends.
              </p>

              <p className="text-[--text-primary]">
                We're grateful you're here. Thanks for letting us be part of your research journey.
              </p>

              {/* --- END OF MODIFIED CONTENT --- */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}